export default function getStyle(field) {
	if (!field['min-width'] && !field['max-width'] && !field.width) {
		return `min-width: 'auto';
				 	max-width: 'auto';
					width: 'auto';`
	}
	const output: any[] = []
	if (field.width) {
		output.push(`width: ${field.width};`)
	}
	if (field['min-width']) {
		output.push(`min-width: ${field['min-width']};`)
	}
	if (field['max-width']) {
		output.push(`max-width: ${field['max-width']};`)
	}

	return output.join('')
}
